import styled from "styled-components";
import { Chip as BaseChip } from "@kitbird/core";
import React, { ComponentProps } from "react";
import { StyledChipWrapper } from "./MutationUser.styled";

type BaseChipProps = ComponentProps<typeof BaseChip>;

interface MultiLineChipProps extends BaseChipProps {
  label: string;
}

export const MultiLineChip: React.FC<MultiLineChipProps> = ({
  label,
  style,
  ...otherProps
}) => {
  const parts = label.split("\n");
  const mainText = parts[0];
  const subText = parts.length > 1 ? parts[1].trim() : "";

  const subtextStyle = {
    "--subtext-content": `"${subText}"`,
  };

  return (
    <StyledChipWrapper
      label={mainText}
      style={{ ...style, ...subtextStyle }}
      {...otherProps}
    />
  );
};

export default MultiLineChip;
